import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Badge from "@react/shared/ui/Badge"

const TONES = {
  todo: {
    ring:  "border-slate-200",
    chip:  "bg-slate-100 text-slate-500",
  },
  done: {
    ring:  "border-emerald-200",
    chip:  "bg-emerald-50 text-emerald-700",
  },
  watch: {
    ring:  "border-amber-200",
    chip:  "bg-amber-50 text-amber-700",
  },
}

const Figure = ({ label, value, muted }) => (
  <div className="flex flex-col gap-0.5 items-end min-w-0 text-right">
    <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-400 whitespace-nowrap">{label}</span>
    <span className={`text-[13px] tabular-nums truncate ${muted ? "text-slate-500" : "text-slate-900 font-semibold"}`}>
      {value}
    </span>
  </div>
)

const ACTION_COLUMN = "w-44 shrink-0 flex justify-end"

const MilestoneRow = ({
  icon,
  tone = "todo",
  step,
  title,
  hint,
  status,
  figures = [],
  action,
  children,
}) => {
  const palette = TONES[tone] || TONES.todo

  return (
    <div className={`bg-white border ${palette.ring} rounded-xl`}>
      <div className="px-4 py-3 flex flex-wrap items-center gap-x-5 gap-y-3">
        <span className={`w-9 h-9 shrink-0 grid place-items-center rounded-full ${palette.chip}`}>
          <FontAwesomeIcon icon={icon} className="text-[13px]" />
        </span>

        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            {step != null && (
              <span className="text-[10px] font-semibold tabular-nums text-slate-400">{step}</span>
            )}
            <span className="text-[13px] font-semibold text-slate-900">{title}</span>
            {status && (
              <Badge tone={status.tone || "neutral"} variant="soft" size="sm">{status.label}</Badge>
            )}
          </div>
          {hint && <p className="text-[11.5px] text-slate-500 mt-0.5">{hint}</p>}
        </div>

        <div className="ml-auto flex items-center gap-x-6 gap-y-3 flex-wrap justify-end">
          {figures.filter(Boolean).map(figure => (
            <Figure key={figure.label} {...figure} />
          ))}

          <div className={ACTION_COLUMN}>{action}</div>
        </div>
      </div>

      {children && <div className="border-t border-slate-100">{children}</div>}
    </div>
  )
}

export default MilestoneRow
